import { render, staticRenderFns } from "./marketdata.component.vue?vue&type=template&id=ea6b71e8"
import script from "./marketdata.component.vue?vue&type=script&lang=js"
export * from "./marketdata.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports